/**
 * Filtres rapides (chips sous la barre de recherche) + panneau de filtres refondu.
 * Un chip coche la case du panneau (#CollectionSidebar .filter-form) et émet « input » :
 * theme.js (Collection.onFormSubmit) fait le reste (AJAX, URL, tags actifs). Aucune requête ici.
 * Fonctions pures exposées sur window.LovenQuickFilters pour les tests.
 */
(function () {
  'use strict';

  var expanded = {};

  /** Case du panneau correspondant à un paramètre + valeur de filtre. */
  function findInput(root, param, value) {
    if (!root) return null;
    var inputs = root.querySelectorAll('.filter-form input.tag__input');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].name === param && inputs[i].value === value) return inputs[i];
    }
    return null;
  }

  /** Libellé du chip coquin : « Côté coquin », « Coquin » ou « Coquin +1 ». */
  function spicySummary(levels, words, fallback) {
    var sorted = levels.slice().sort(function (a, b) { return a - b; });
    if (!sorted.length) return fallback;
    var first = words[sorted[0]] || fallback;
    return sorted.length === 1 ? first : first + ' +' + (sorted.length - 1);
  }

  /** En mode ET (data-single), cocher un cran décoche les autres. Retourne les cases décochées. */
  function enforceSingle(list, checkedInput) {
    var cleared = [];
    if (!list || list.getAttribute('data-single') !== '1' || !checkedInput.checked) return cleared;
    list.querySelectorAll('input.tag__input').forEach(function (el) {
      if (el !== checkedInput && el.checked) {
        el.checked = false;
        var li = el.closest('li');
        if (li) li.classList.remove('tag--active');
        cleared.push(el);
      }
    });
    return cleared;
  }

  function sidebar() {
    return document.getElementById('CollectionSidebar');
  }

  function syncChips() {
    var root = sidebar();
    document.querySelectorAll('[data-lns-quick]').forEach(function (chip) {
      var input = findInput(root, chip.getAttribute('data-param'), chip.getAttribute('data-value'));
      var on = !!(input && input.checked);
      chip.setAttribute('aria-pressed', on ? 'true' : 'false');
      var li = input && input.closest('li');
      chip.hidden = !input || (!on && !!li && li.classList.contains('hide'));
    });
    var spicyChip = document.querySelector('[data-lns-quick-spicy]');
    if (spicyChip) {
      var levels = [];
      var words = {};
      var spiceInputs = root ? root.querySelectorAll('.lns-spice__input') : [];
      spiceInputs.forEach(function (el) {
        var n = parseInt(el.getAttribute('data-level'), 10);
        var text = el.closest('label').querySelector('.tag__text');
        words[n] = text ? text.textContent.trim() : String(n);
        if (el.checked) levels.push(n);
      });
      var label = spicyChip.querySelector('[data-lns-quick-spicy-label]');
      if (label) label.textContent = spicySummary(levels, words, label.getAttribute('data-default'));
      spicyChip.setAttribute('data-active', levels.length ? 'true' : 'false');
      spicyChip.hidden = !spiceInputs.length;
    }
  }

  function applyExpanded() {
    Object.keys(expanded).forEach(function (gid) {
      if (!expanded[gid]) return;
      document.querySelectorAll('[data-lns-group="' + gid + '"]').forEach(setGroupOpen.bind(null, true));
    });
  }

  function setGroupOpen(open, group) {
    group.classList.toggle('is-expanded', open);
    var btn = group.querySelector('[data-lns-more]');
    if (!btn) return;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    var lbl = btn.querySelector('[data-lns-more-label]');
    if (lbl) {
      if (!lbl.getAttribute('data-more')) lbl.setAttribute('data-more', lbl.textContent);
      lbl.textContent = open ? btn.getAttribute('data-less') || 'Afficher moins' : lbl.getAttribute('data-more');
    }
  }

  function openPanelAt(groupId) {
    var opener = document.getElementById('collection-open-filters-head');
    if (!opener || window.getComputedStyle(opener).display === 'none') {
      opener = document.getElementById('collection-open-filters') || opener;
    }
    if (!opener) return;
    opener.click();
    setTimeout(function () {
      var group = document.getElementById(groupId);
      var body = document.getElementById('collection-filters-modal-body');
      if (!group || !body) return;
      body.scrollTop = Math.max(0, group.offsetTop - body.offsetTop - 8);
      var first = group.querySelector('input.tag__input');
      if (first) first.focus({ preventScroll: true });
    }, 80);
  }

  function onClick(e) {
    var chip = e.target.closest('[data-lns-quick]');
    if (chip) {
      var input = findInput(sidebar(), chip.getAttribute('data-param'), chip.getAttribute('data-value'));
      if (!input) return;
      input.checked = !input.checked;
      chip.setAttribute('aria-pressed', input.checked ? 'true' : 'false');
      input.dispatchEvent(new Event('input', { bubbles: true }));
      return;
    }
    if (e.target.closest('[data-lns-quick-spicy]')) {
      openPanelAt('lns-fgroup-spicy');
      return;
    }
    var more = e.target.closest('[data-lns-more]');
    if (more) {
      e.preventDefault();
      var group = more.closest('[data-lns-group]');
      var gid = group.getAttribute('data-lns-group');
      expanded[gid] = !group.classList.contains('is-expanded');
      setGroupOpen(expanded[gid], group);
    }
  }

  function onInputCapture(e) {
    var el = e.target;
    if (!el || !el.classList || !el.classList.contains('lns-spice__input')) return;
    enforceSingle(el.closest('.lns-spice-list'), el);
  }

  function init() {
    if (window.__lnsQuickFiltersBound) return;
    window.__lnsQuickFiltersBound = true;
    document.addEventListener('click', onClick);
    document.addEventListener('input', onInputCapture, true);
    document.addEventListener('collection:reloaded', function () {
      applyExpanded();
      syncChips();
    });
    syncChips();
  }

  window.LovenQuickFilters = { findInput: findInput, spicySummary: spicySummary, enforceSingle: enforceSingle, syncChips: syncChips };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
